var map = {
	"./accessories.svg": 206786,
	"./bags.svg": 382113,
	"./clothing.svg": 156304,
	"./home-and-living.svg": 793509,
	"./home-decor.svg": 182185,
	"./paper.svg": 625458,
	"./store.svg": 128835,
	"./wall-art.svg": 302060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744138;